module.exports = __webpack_public_path__ + "static/media/startup-slider-1.d31eaa72.png";